import classNames from 'classnames';
import { ReactNode } from 'react';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import './DashboardTotalCard.scss';

interface IDashboardTotalCardProps {
  label?: ReactNode;
  value?: ReactNode;
  variant?: BUTTON_VARIANT;
}

const DashboardTotalCard = ({
  label,
  value,
  variant = BUTTON_VARIANT.default,
}: IDashboardTotalCardProps) => {
  const className = classNames(['dashboard-total-card', BUTTON_VARIANT[variant]], {});
  return (
    <div className={className}>
      <div className="dashboard-total-card-label">{label} </div>
      <div className="dashboard-total-card-value">{value}</div>
    </div>
  );
};

export default DashboardTotalCard;
